import React from 'react';

// Bulk actions over the ticked sources.
//
// These loop the single-row endpoints client-side rather than hitting a bulk API,
// so they are NOT atomic: the page reports how many actually succeeded rather than
// claiming success (spec V5-4).
export default function EditBar({ count, onTurnOff, onRemove, busy = false }) {
  const none = count === 0 || busy;
  return (
    <div className="flex items-center gap-3 flex-wrap rounded-lg border border-dashed border-gray-300 bg-gray-50 px-4 py-2.5 mb-4 text-sm text-gray-700">
      <span><b>Edit mode.</b> Tick sources to act on several at once.</span>
      <span className="text-gray-500">{count} selected</span>
      <span className="flex-1" />
      <button
        type="button"
        disabled={none}
        onClick={onTurnOff}
        className="px-3 py-1.5 text-xs font-semibold rounded-lg border border-gray-200 text-gray-600 hover:border-gray-400 disabled:opacity-40"
      >
        Turn off selected
      </button>
      <button
        type="button"
        disabled={none}
        onClick={onRemove}
        className="px-3 py-1.5 text-xs font-semibold rounded-lg text-red-700 hover:bg-red-50 disabled:opacity-40"
      >
        Remove selected
      </button>
    </div>
  );
}
